module.exports = __webpack_public_path__ + "static/dwayne-johnson-dbc23091fbf232015125cfae235b460a.jpg";